import { HTTP_STATUS } from "../../constants/httpStatus"
import rippleLogo from '../../assets/icons/rippleLogo.png'


const DEFAULT = { status: null, data: null, error: null }
const rippleHolding = { id: 0, name: 'XRPL', unit: 'Xrp', image: rippleLogo }
const DEFAULT_HOLDINGS = { ...DEFAULT, data: [rippleHolding] }

export const createRippleWalletPending = (state) => {
    state.createWallet.status = HTTP_STATUS.PENDING
}

export const createRippleWalletFulfilled = (state, { payload }) => {
    state.createWallet.status = HTTP_STATUS.FULFILLED
    state.createWallet.data = payload
    state.id = payload.id
    state.seed = payload.wallet_seed
    state.address = payload.address
    state.createWallet.error = null
}

export const createRippleWalletRejected = (state, { payload }) => {
    state.createWallet.status =  HTTP_STATUS.REJECTED
    state.createWallet.error = payload
}

export const getActiveRippleWalletPending = (state) => {
    state.activeWallet.status = HTTP_STATUS.PENDING
}

export const getActiveRippleWalletFulfilled = (state, { payload }) => {
    state.activeWallet.status = HTTP_STATUS.FULFILLED
    state.activeWallet.data = payload
}

export const getActiveRippleWalletRejected = (state, { payload }) => {
    state.activeWallet.status =  HTTP_STATUS.REJECTED
    state.activeWallet.error = payload
}

export const getRippleTransactionsPending = (state) => {
    state.transactions.status = HTTP_STATUS.PENDING
}

export const getRippleTransactionsFulfilled = (state, { payload }) => {
    state.transactions.status = HTTP_STATUS.FULFILLED
    state.transactions.data = payload
}

export const getRippleTransactionsRejected = (state, { payload }) => {
    state.transactions.status =  HTTP_STATUS.REJECTED
    state.transactions.error = payload
}

export const createRippleAssetPending = (state) => {
    state.createAsset.status = HTTP_STATUS.PENDING
}

export const createRippleAssetFulfilled = (state, { payload }) => {
    state.createAsset.status = HTTP_STATUS.FULFILLED
    state.createAsset.data = payload
}

export const createRippleAssetRejected = (state, { payload }) => {
    state.createAsset.status =  HTTP_STATUS.REJECTED
    state.createAsset.error = payload
}


export const createEscrowPending = (state) => {
    state.createEscrow.status = HTTP_STATUS.PENDING
}

export const createEscrowFulfilled = (state, { payload }) => {
    state.createEscrow.status = HTTP_STATUS.FULFILLED
    state.createEscrow.data = payload
}

export const createEscrowRejected = (state, { payload }) => {
    state.createEscrow.status =  HTTP_STATUS.REJECTED
    state.createEscrow.error = payload
}


export const scheduleEscrowPending = (state) => {
    state.scheduleEscrow.status = HTTP_STATUS.PENDING
}

export const scheduleEscrowFulfilled = (state, { payload }) => {
    state.scheduleEscrow.status = HTTP_STATUS.FULFILLED
    state.scheduleEscrow.data = payload
}

export const scheduleEscrowRejected = (state, { payload }) => {
    state.scheduleEscrow.status =  HTTP_STATUS.REJECTED
    state.scheduleEscrow.error = payload
}


export const finishEscrowPending = (state) => {
    state.finishEscrow.status = HTTP_STATUS.PENDING
}

export const finishEscrowFulfilled = (state, { payload }) => {
    state.finishEscrow.status = HTTP_STATUS.FULFILLED
    state.finishEscrow.data = payload
}

export const finishEscrowRejected = (state, { payload }) => {
    state.finishEscrow.status =  HTTP_STATUS.REJECTED
    state.finishEscrow.error = payload
}


export const cancelEscrowPending = (state) => {
    state.cancelEscrow.status = HTTP_STATUS.PENDING
}

export const cancelEscrowFulfilled = (state, { payload }) => {
    state.cancelEscrow.status = HTTP_STATUS.FULFILLED
    state.cancelEscrow.data = payload
}

export const cancelEscrowRejected = (state, { payload }) => {
    state.cancelEscrow.status =  HTTP_STATUS.REJECTED
    state.cancelEscrow.error = payload
}

export const getRippleHoldingsPending = (state) => {
    state.holdings.status = HTTP_STATUS.PENDING
}

export const getRippleHoldingsFulfilled = (state, { payload }) => {
    state.holdings.status = HTTP_STATUS.FULFILLED
    state.holdings.data = [rippleHolding, ...payload]
}

export const getRippleHoldingsRejected = (state, { payload }) => {
    state.holdings.status = HTTP_STATUS.REJECTED
    state.holdings.error = payload
}

export const rippleOptInPending = (state) => {
    state.optIn.status = HTTP_STATUS.PENDING
}

export const rippleOptInFulfilled = (state, { payload }) => {
    state.optIn.status = HTTP_STATUS.FULFILLED
    state.optIn.data = payload
}

export const rippleOptInRejected = (state, { payload }) => {
    state.optIn.status = HTTP_STATUS.REJECTED
    state.optIn.error = payload
}

export const rippleOptOutPending = (state) => {
    state.optOut.status = HTTP_STATUS.PENDING
}

export const rippleOptOutFulfilled = (state, { payload }) => {
    state.optOut.status = HTTP_STATUS.FULFILLED
    state.optOut.data = payload
}

export const rippleOptOutRejected = (state, { payload }) => {
    state.optOut.status = HTTP_STATUS.REJECTED
    state.optOut.error = payload
}

export const getCreatedAssetsPending = (state) => {
    state.createdAssets.status = HTTP_STATUS.PENDING
}

export const getCreatedAssetsFulfilled = (state, { payload }) => {
    state.createdAssets.status = HTTP_STATUS.FULFILLED
    state.createdAssets.data = payload
}

export const getCreatedAssetsRejected = (state, { payload }) => {
    state.createdAssets.status = HTTP_STATUS.REJECTED
    state.createdAssets.error = payload
}

export const getAllRippleWalletsPending = (state) => {
    state.allWallets.status = HTTP_STATUS.PENDING
}

export const getAllRippleWalletsFulfilled = (state, { payload }) => {
    state.allWallets.status = HTTP_STATUS.FULFILLED
    state.allWallets.data = payload
}

export const getAllRippleWalletsRejected = (state, { payload }) => {
    state.allWallets.status = HTTP_STATUS.REJECTED
    state.allWallets.error = payload
}

export const updateActiveRippleWalletPending = (state) => {
    state.updateActiveWallet.status = HTTP_STATUS.PENDING
}

export const updateActiveRippleWalletFulfilled = (state, { payload }) => {
    state.updateActiveWallet.status = HTTP_STATUS.FULFILLED
    state.updateActiveWallet.data = payload
    state.holdings = DEFAULT_HOLDINGS
    state.createdAssets = DEFAULT
    state.transactions = DEFAULT
    state.allWallets = DEFAULT
}

export const updateActiveRippleWalletRejected = (state, { payload }) => {
    state.updateActiveWallet.status = HTTP_STATUS.REJECTED
    state.updateActiveWallet.error = payload
}

export const removeRippleWalletPending = (state) => {
    state.removeWallet.status = HTTP_STATUS.PENDING
}

export const removeRippleWalletFulfilled = (state, { payload }) => {
    state.removeWallet.status = HTTP_STATUS.FULFILLED
    state.removeWallet.data = 'removed wallet'
    state.holdings = DEFAULT_HOLDINGS
    state.createdAssets = DEFAULT
    state.transactions = DEFAULT
}

export const removeRippleWalletRejected = (state, { payload }) => {
    state.removeWallet.status = HTTP_STATUS.REJECTED
    state.removeWallet.error = payload
}

export const sendRipplePending = (state) => {
    state.send.status = HTTP_STATUS.PENDING
}

export const sendRippleFulfilled = (state, { payload }) => {
    state.send.status = HTTP_STATUS.FULFILLED
    state.send.data = payload
}

export const sendRippleRejected = (state, { payload }) => {
    state.send.status = HTTP_STATUS.REJECTED
    state.send.error = payload
}


export const createRippleOfferPending = (state) => {
    state.createOffer.status = HTTP_STATUS.PENDING
}

export const createRippleOfferFulfilled = (state, { payload }) => {
    state.createOffer.status = HTTP_STATUS.FULFILLED
    state.createOffer.data = payload
}

export const createRippleOfferRejected = (state, { payload }) => {
    state.createOffer.status = HTTP_STATUS.REJECTED
    state.createOffer.error = payload
}


export const searchRippleOffersPending = (state) => {
    state.offers.status = HTTP_STATUS.PENDING
}

export const searchRippleOffersFulfilled = (state, { payload }) => {
    state.offers.status = HTTP_STATUS.FULFILLED
    state.offers.data = payload
}

export const searchRippleOffersRejected = (state, { payload }) => {
    state.offers.status = HTTP_STATUS.REJECTED
    state.offers.error = payload
}


export const getCreateEscrowListPending = (state) => {
    state.createEscrowList.status = HTTP_STATUS.PENDING
}

export const getCreateEscrowListFulfilled = (state, { payload }) => {
    state.createEscrowList.status = HTTP_STATUS.FULFILLED
    state.createEscrowList.data = payload
}

export const getCreateEscrowListRejected = (state, { payload }) => {
    state.createEscrowList.status = HTTP_STATUS.REJECTED
    state.createEscrowList.error = payload
}


export const getFinishEscrowListPending = (state) => {
    state.finishEscrowList.status = HTTP_STATUS.PENDING
}

export const getFinishEscrowListFulfilled = (state, { payload }) => {
    state.finishEscrowList.status = HTTP_STATUS.FULFILLED
    state.finishEscrowList.data = payload
}

export const getFinishEscrowListRejected = (state, { payload }) => {
    state.finishEscrowList.status = HTTP_STATUS.REJECTED
    state.finishEscrowList.error = payload
}


export const getCancelEscrowListPending = (state) => {
    state.cancelEscrowList.status = HTTP_STATUS.PENDING
}

export const getCancelEscrowListFulfilled = (state, { payload }) => {
    state.cancelEscrowList.status = HTTP_STATUS.FULFILLED
    state.cancelEscrowList.data = payload
}

export const getCancelEscrowListRejected = (state, { payload }) => {
    state.cancelEscrowList.status = HTTP_STATUS.REJECTED
    state.cancelEscrowList.error = payload
}


export const getAccountEscrowListPending = (state) => {
    state.accountEscrowList.status = HTTP_STATUS.PENDING
}

export const getAccountEscrowListFulfilled = (state, { payload }) => {
    state.accountEscrowList.status = HTTP_STATUS.FULFILLED
    state.accountEscrowList.data = payload
}

export const getAccountEscrowListRejected = (state, { payload }) => {
    state.accountEscrowList.status = HTTP_STATUS.REJECTED
    state.accountEscrowList.error = payload
}


export const getAccountCheckListPending = (state) => {
    state.accountCheckList.status = HTTP_STATUS.PENDING
}

export const getAccountCheckListFulfilled = (state, { payload }) => {
    state.accountCheckList.status = HTTP_STATUS.FULFILLED
    state.accountCheckList.data = payload
}

export const getAccountCheckListRejected = (state, { payload }) => {
    state.accountCheckList.status = HTTP_STATUS.REJECTED
    state.accountCheckList.error = payload
}


export const cashXrpCheckPending = (state) => {
    state.cashCheck.status = HTTP_STATUS.PENDING
}

export const cashXrpCheckFulfilled = (state, { payload }) => {
    state.cashCheck.status = HTTP_STATUS.FULFILLED
    state.cashCheck.data = payload
}

export const cashXrpCheckRejected = (state, { payload }) => {
    state.cashCheck.status = HTTP_STATUS.REJECTED
    state.cashCheck.error = payload
}


export const cashAssetCheckPending = (state) => {
    state.cashCheck.status = HTTP_STATUS.PENDING
}

export const cashAssetCheckFulfilled = (state, { payload }) => {
    state.cashCheck.status = HTTP_STATUS.FULFILLED
    state.cashCheck.data = payload
}

export const cashAssetCheckRejected = (state, { payload }) => {
    state.cashCheck.status = HTTP_STATUS.REJECTED
    state.cashCheck.error = payload
}


export const cancelCheckPending = (state) => {
    state.cancelCheck.status = HTTP_STATUS.PENDING
}

export const cancelCheckFulfilled = (state, { payload }) => {
    state.cancelCheck.status = HTTP_STATUS.FULFILLED
    state.cancelCheck.data = payload
}

export const cancelCheckRejected = (state, { payload }) => {
    state.cancelCheck.status = HTTP_STATUS.REJECTED
    state.cancelCheck.error = payload
}


export const getPendingRippleOffersPending = (state) => {
    state.pendingOffers.status = HTTP_STATUS.PENDING
}

export const getPendingRippleOffersFulfilled = (state, { payload }) => {
    state.pendingOffers.status = HTTP_STATUS.FULFILLED
    state.pendingOffers.data = payload
}

export const getPendingRippleOffersRejected = (state, { payload }) => {
    state.pendingOffers.status = HTTP_STATUS.REJECTED
    state.pendingOffers.error = payload
}


export const setRippleNetPending = (state) => {
    state.setNet.status = HTTP_STATUS.PENDING
}

export const setRippleNetFulfilled = (state, { payload }) => {
    state.setNet.status = HTTP_STATUS.FULFILLED
}

export const setRippleNetRejected = (state, { payload }) => {
    state.setNet.status = HTTP_STATUS.REJECTED
    state.setNet.error = payload
}


export const getRippleFeePending = (state) => {
    state.fee.status = HTTP_STATUS.PENDING
}

export const getRippleFeeFulfilled = (state, { payload }) => {
    state.fee.status = HTTP_STATUS.FULFILLED
    state.fee.data = payload
}

export const getRippleFeeRejected = (state, { payload }) => {
    state.fee.status = HTTP_STATUS.REJECTED
    state.fee.error = payload
}